import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../cn';
import styles from './Tabs.module.css';

export function Tabs({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div role="tablist" className={cn(styles.tabs, className)} {...rest}>{children}</div>;
}

export interface TabProps extends HTMLAttributes<HTMLDivElement> {
  active?: boolean;
  count?: number | string;
  leftIcon?: ReactNode;
}

export function Tab({ active, count, leftIcon, className, children, ...rest }: TabProps) {
  return (
    <div
      role="tab"
      aria-selected={active}
      tabIndex={active ? 0 : -1}
      className={cn(styles.tab, active && styles.active, className)}
      {...rest}
    >
      {leftIcon}
      <span>{children}</span>
      {count !== undefined && <span className={styles.count}>{count}</span>}
    </div>
  );
}
